/* ============================================================
   Dathent — onboardingCompletion.js (TASK-214, issue #332)
   One in-memory "onboarding just completed" timestamp, shared by the
   RequireOnboarding gate (App.jsx) and the dashboard "Finish setup" card.
   Onboarding writes the brand profile at completion; for up to a minute a
   D1 read replica may still 404 on GET /api/brand-profile. The gate used to
   keep this as a module-level `let` inside App.jsx — moved here so the
   dashboard can honour the same grace window without importing App.jsx
   (which imports the dashboard — a cycle).

   Deliberately NOT localStorage: the removed guard that once bricked the
   app keyed off a stuck local "activation stash". In-memory means a reload
   re-asks the server, which is the safe side.
   ============================================================ */

export const ONBOARDING_COMPLETION_GRACE_MS = 60000;

let completedAt = 0;

export function markOnboardingCompleted(now = Date.now()) {
  completedAt = now;
}

export function onboardingJustCompleted(now = Date.now()) {
  return completedAt > 0 && now - completedAt < ONBOARDING_COMPLETION_GRACE_MS;
}
